import {useLocation} from 'react-router-dom';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import ReactWebChat, {createDirectLine, createStore} from 'botframework-webchat';
import styleOptions from '../asset/js/styleSet.js';
import Header from "./Header";
import './WebChat.css';
import {Col, Container, Row} from "react-bootstrap";
import sendButton from '../asset/send.png';
import utils from '../helpers/Utils'
import attach_icon from '../asset/logo-upload.png';

const WebChat = (factory, deps) => {


    const {search} = useLocation();
    const jobId = useMemo(() => new URLSearchParams(search).get("jobId"), [search]);
    const tp = useMemo(() => new URLSearchParams(search).get("tp"), [search]);
    //initialize directLine state

    const [styleSet, setStyleOptions] = useState();
    const [session, setSession] = useState();

    useEffect(() => {
        if ((jobId !== "520" && jobId !== "539" && jobId !== "632" && jobId !== "633" && jobId !== "2826" && jobId !== "8506" && jobId !== "2827" && jobId !=="8507" && jobId !== "2955" && jobId !== "2956") || (tp !== "WEB-ORACLE" && tp !== "WEB-APRICA" && tp !== "WEB-AMSA")) {
            setSession(false);
        }
    });
    useMemo(() => setStyleOptions(styleOptions()), []);

    const initConversation = useCallback(() => {

        setSession(false);

        (async function () {
            const token = await fetchToken();
            const key = Date.now();

            setSession({
                directLine: createDirectLine({token}),
                key,
                store: createStore({}, ({dispatch}) => next => action => {
                    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                        dispatch({
                            type: 'WEB_CHAT/SEND_EVENT',
                            payload: {
                                name: 'webchat/join',
                                value: {
                                    jobId: jobId,
                                    tp: tp
                                }
                            }
                        });
                    } else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
                        let activity = action.payload.activity
                        var buttons=document.getElementsByClassName("ac-pushButton");
                        for (let i = 0; i < buttons.length; i++){
                            buttons[i].onclick = null
                            buttons[i].style.pointerEvents = "none";
                        }
                        if (action.payload.activity.from.role === 'bot') {
                            if (activity.attachments === undefined && activity.suggestedActions === undefined && activity.value === undefined) {
                                enableSendBoxMain()
                                enableInput()
                                disableUpload()
                                enableKeyboard()
                            } else if (activity.attachments !== undefined && activity.attachments.length > 0) {
                                disableInput()
                                disableSendBoxMain()
                                disableUpload()
                                disableKeyboard()
                            } else if (activity.suggestedActions !== undefined && activity.suggestedActions.actions.length > 0) {
                                enableInput()
                                disableSendBoxMain()
                                disableUpload()
                            } else if (activity.value !== undefined && activity.value === "enableAttachment") {
                                enableInput()
                                enableSendBoxMain()
                                disableKeyboard()
                                enableUpload()
                            } else if (activity.value !== undefined && activity.value !== null && activity.value.endOfConversation === true) {
                                disableInput()
                                disableSendBoxMain()
                                disableUpload()
                                disableKeyboard()
                            }
                        return next(action)
                        }

                    }else if (action.type === 'WEB_CHAT/SEND_FILES') {

                        const fileSize = Math.round(action.payload.files[0].size / 1000);

                        if(fileSize >= 4 * 1024){
                            // send message that input is not valid
                            console.log("input size: ", fileSize, " not allowed")
                            dispatch({
                                type: 'WEB_CHAT/SET_NOTIFICATION',
                                payload: {
                                    alt: 'Input size not allowed.',
                                    id: 'attachment-size',
                                    level: 'error',
                                    message: "La massima dimensione supportata è di 4Mb. Riprova con un file di dimensioni inferiori."
                                }
                            });
                            return null;
                        }else{
                            dispatch({
                                type: 'WEB_CHAT/DISMISS_NOTIFICATION',
                                payload: {
                                    id: 'attachment-size'
                                }
                            });
                            return next(action)
                        }

                    }
                return next(action);
                })
            });
        })();
    }, [setSession]);
    useEffect(initConversation, [initConversation]);

    async function fetchToken() {
        let url = "./api/directline/token"
        if (!utils.getEnv("REACT_APP_TOKEN_URL") === undefined || utils.getEnv("REACT_APP_TOKEN_URL"))
            url = utils.getEnv("REACT_APP_TOKEN_URL")
        const res = await fetch(url, {
            method: 'POST'
        });

        const {token} = await res.json();
        return token;
    }

    function disableSendBoxMain() {
        let input = document.getElementsByClassName("webchat__send-box__main");
        if (input[0] !== null && input[0] !== undefined)
            input[0].style.display = "none"
    }

    function disableInput() {
        let input = document.getElementsByClassName("webchat__send-box");
        if (input[0] !== null && input[0] !== undefined)
            input[0].style.display = "none"
    }

    function disableUpload() {
        let input = document.getElementsByClassName("webchat__upload-button");
        if (input[0] !== null && input[0] !== undefined)
            input[0].style.display = "none"
    }

    function enableUpload() {
        let input = document.getElementsByClassName("webchat__upload-button");
        let ls = document.getElementsByClassName("webchat__send-box__main");
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        const child = ls[0].children[0].getElementsByTagName('svg');
        let x = ls[0].children[0];
        ls[0].append(x);
        ls[0].children[1].style.display = "none";
        img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', attach_icon);
        img.setAttribute('height', '30');
        img.setAttribute('width', '40');
        // img.src= sendButton;
        svg.setAttribute('height', '30');
        svg.setAttribute('width', '40');
        svg.appendChild(img);
        child[0].replaceWith(svg)
        input[0].style.display = "flex"
    }

    function enableInput() {
        let input = document.getElementsByClassName("webchat__send-box");
        let ls = document.getElementsByClassName("webchat__send-box__main");
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        const child = ls[0].children[2].getElementsByTagName('svg');
        img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', sendButton);
        img.setAttribute('height', '28');
        img.setAttribute('width', '28');
        // img.src= sendButton;
        svg.setAttribute('height', '28');
        svg.setAttribute('width', '28');
        svg.appendChild(img);
        child[0].replaceWith(svg)
        input[0].style.display = "block"
    }

    function enableSendBoxMain() {
        let input = document.getElementsByClassName("webchat__send-box__main");
        input[0].style.display = "flex"
    }

    function disableKeyboard() {
        let input = document.getElementsByClassName("webchat__send-box-text-box__input");
        let button = document.getElementsByClassName("webchat__send-button");
        input[0].disabled = true
        button[0].disabled = true
    }

    function enableKeyboard() {
        let input = document.getElementsByClassName("webchat__send-box-text-box__input");
        let button = document.getElementsByClassName("webchat__send-button");
        input[0].disabled = false
        button[0].disabled = false
    }


    function onReset(e) {

        initConversation()
    }


    return (
        <>
            {
                (session)
                    ?
                    <Container fluid="true">
                        <Row className="m-0 p-0">
                            <Col className=" m-0 p-0">
                                <Header onReset={e => onReset(e)} jobId={jobId}>
                                </Header>
                                <ReactWebChat className="webchat"
                                              directLine={session.directLine}
                                              key={session.key}
                                              store={session.store}
                                              styleOptions={styleSet}
                                    // attachmentMiddleware={attachmentMiddleware}
                                    // activityMiddleware={middleware}
                                              sendTypingIndicator={true}
                                />
                            </Col>

                        </Row>
                    </Container>
                    : <div>
                        Caricamento...
                    </div>
            }
        </>
    )
};

export default WebChat;
